import moment from 'moment';
import { PropTypes } from 'prop-types';
import { getWeekday } from '../utils/CommonFunctions';
import { ChatWrapperCss } from '../utils/WrapperCss';
import { ORIENTAL_BANK_LOGO } from '../../../Constants';
import { API_CONFIG } from '../../../config/apiconfig';

const useChatWrapperCss = ChatWrapperCss();
const ChatLogo = (props) => {
  const WrapperCss = useChatWrapperCss();
  const { englishBot, baseURL } = props;
  return (
    <>
      <div className={WrapperCss.logo_container}>
        <img
          src={`${baseURL?.IMAGE_BASE_URL}${API_CONFIG.CHATBOT_LOGO_URL}`}
          alt={ORIENTAL_BANK_LOGO}
          // width="70"
          // height="70"
          tabIndex="101"
        />
      </div>
      <div className={WrapperCss.today_date}>
        <span>
          {getWeekday(englishBot)}
          {moment().format(', h:mm A')}
        </span>
      </div>
    </>
  );
};
ChatLogo.propTypes = {
  englishBot: PropTypes.bool,
  baseURL: PropTypes.object,
};
export default ChatLogo;
